// Generated by CoffeeScript 2.7.0
// Usage:
// create a node
// rawAttrs = {
//   id: 2,
//   ancestry: '1',
//   name: 'attr-name
// }
// node = new HierarchicalTreeNode(rawAttrs)
// rawAttrs must contain id and ancestry
// properties of rawAttrs will be delegated to node
// node.name #= attr-name
// node.parent #= Return parent node if it exists, otherwise null
// node.children
// node.parent_id #= Return parent_id
// node.path_ids #= [1, 2]
// node.ancestor_ids #= [1]
// node.findChildById(child_id)
// node.findDescentByNodeIds([1, 2])
// node.getDescendants()

// nodes = [node]
// create a Hierarchy with nodes
// hierarchy = new Hierarchy(nodes)
// hierarchy.trees # Return an array of HierarchicalTree
// firstTree.root # Return root node(HierarchicalTree) of firstTree

// otherNodes = [...] # An array of HierarchicalTreeNode
// hierarchy.addNodes(otherNodes)
var HierarchicalTree, HierarchicalTreeNode, Hierarchy, OMITTED_ATTRIBUTES, parseAncestry;

parseAncestry = function(ancestry) {
  if (!ancestry) {
    return [];
  }
  return _.chain(ancestry.split('/')).map(function(strId) {
    return parseInt(strId);
  }).compact().value();
};

OMITTED_ATTRIBUTES = ['children', 'parent', 'hierarchy'];

HierarchicalTreeNode = (function() {
  class HierarchicalTreeNode {
    constructor(_attrs = {}) {
      this._attrs = _attrs;
      if (!(_.has(this._attrs, 'id') && _.has(this._attrs, 'ancestry'))) {
        throw new Error('Missing id or ancestry.');
      }
      ({id: this.id, ancestry: this.ancestry} = this._attrs);
      this._formatProps();
      // Init props
      this.parent = null;
      this.parent_id = _.last(this.ancestor_ids) || null;
      this.root_id = _.first(this.path_ids);
      this.children = [];
      // Delegate props to _attrs except HOLDER_PROPS
      _.chain(this._attrs).keys().difference(this.HOLDER_PROPS).each((attr_name) => {
        return this._delegateProp(attr_name);
      });
      Object.defineProperty(this, 'isLeaf', {
        get: function() {
          return !this.children_count;
        }
      });
      Object.defineProperty(this, 'path', {
        get: function() {
          var _result, node;
          _result = [this];
          node = this;
          while (node.parent) {
            _result.unshift(node.parent);
            node = node.parent;
          }
          return _result;
        }
      });
      Object.defineProperty(this, 'isLeafLike', {
        get: function() {
          return Boolean(this.isLeaf || this.isVirtual);
        }
      });
    }

    getAttr(attr_name) {
      return this._attrs[attr_name];
    }

    findChildById(child_id) {
      return _.find(this.children, function(child) {
        return child.id === child_id;
      }) || null;
    }

    findDescentByNodeIds(_ids) {
      var _id, _node, i, len;
      if (!_ids.length) {
        return null;
      }
      if (_.isEqual(_ids, this.path_ids)) {
        return this;
      }
      _ids = _.difference(_ids, this.path_ids);
      _node = this;
      if (!_ids.length) {
        return null;
      }
      for (i = 0, len = _ids.length; i < len; i++) {
        _id = _ids[i];
        if (_node) {
          _node = _node.findChildById(_id);
        } else {
          _node = null;
          break;
        }
      }
      return _node;
    }

    addChild(child) {
      if (child.ancestry.search(this.ancestry) === 0) {
        return this.children.push(child);
      } else {
        throw new Error('Invalid ancestry.');
      }
    }

    removeChild(child) {
      this.children = _.reject(this.children, function(item) {
        return item.id === child.id;
      });
      this.children_count -= 1;
      return child.parent = null;
    }

    getDescendants() {
      return _.flatten(_.map(this.children, function(child) {
        return child.getDescendantsAndSelf();
      }));
    }

    getDescendantsAndSelf() {
      return _.union([this], this.getDescendants());
    }

    getSiblings() {
      if (this.parent) {
        return this.parent.children;
      } else {
        return this.hierarchy.getRootNodes();
      }
    }

    _formatProps() {
      // Parse id to an int
      this.id = parseInt(this.id);
      if (_.isNaN(this.id)) {
        throw new Error('Expected node to be a Node.');
      }
      this.ancestor_ids = parseAncestry(this.ancestry);
      this.path_ids = this.ancestor_ids.concat(this.id);
      // Format ancestry like '   /1/  2/3  ' to '/1/2/3'
      return this.ancestry = this.ancestor_ids.join('/');
    }

    _delegateProp(attr_name) {
      return Object.defineProperty(this, attr_name, {
        get: function() {
          return this._attrs[attr_name];
        },
        set: function(newValue) {
          return this._attrs[attr_name] = newValue;
        },
        enumerable: true,
        configurable: true
      });
    }

  };

  HierarchicalTreeNode.prototype.HOLDER_PROPS = ['id', 'ancestry'];

  return HierarchicalTreeNode;

}).call(this);

HierarchicalTree = class HierarchicalTree {
  constructor(root) {
    this.root = root;
  }

  findNodeByPath(path) {
    return this.root.findDescentByNodeIds(parseAncestry(path));
  }

  addNode(node) {
    var child, parent;
    parent = this.root.findDescentByNodeIds(node.ancestor_ids);
    if (parent) {
      child = parent.findChildById(node.id);
      if (child) {
        // omit blank children and parent on node
        _.extend(child, _.omit(node, ...OMITTED_ATTRIBUTES));
        // make sure node is the last one
        if (parent.children_count !== parent.children.length) {
          parent.children = _.without(parent.children, child);
          parent.addChild(child);
        }
        return child;
      } else {
        node.parent && node.parent.removeChild(node);
        node.parent = parent;
        parent.addChild(node);
        return node;
      }
    } else {
      if (this.root.id === node.id) {
        // update newNode attributes to oldNode
        _.extend(this.root, _.omit(node, ...OMITTED_ATTRIBUTES));
        return this.root;
      } else if (this.root.parent_id === node.id) {
        this.root.parent = node;
        node.addChild(this.root);
        return this.root = node;
      } else {
        return false;
      }
    }
  }

  removeNode(node) {
    var parent;
    parent = this.root.findDescentByNodeIds(node.ancestor_ids);
    if (parent) {
      parent.removeChild(node);
    } else if (node.parent) {
      node.parent.removeChild(node);
    }
    return node;
  }

};

Hierarchy = class Hierarchy {
  constructor(nodes = [], nodeParser = null) {
    this.nodeParser = nodeParser;
    this.trees = [];
    this.addNodes(nodes);
  }

  getRootNodes() {
    return _.map(this.trees, function(tree) {
      return tree.root;
    });
  }

  getAllNodes() {
    return this.allNodesIteratee().value();
  }

  allNodesIteratee() {
    return _.chain(this.getRootNodes()).map(function(root) {
      return root.getDescendantsAndSelf();
    }).flatten().compact();
  }

  addNodes(nodes) {
    return _.map(nodes, (node) => {
      var _tree, _trees, added, i, len, oldNode;
      if (!(node instanceof HierarchicalTreeNode)) {
        node = new HierarchicalTreeNode(this.nodeParser ? this.nodeParser(node) : node);
      }
      node.hierarchy = this;
      _trees = this._findRelaventTreesByRootId(node.root_id);
      if (_trees.length) {
        added = false;
        for (i = 0, len = _trees.length; i < len; i++) {
          _tree = _trees[i];
          if (oldNode = _tree.addNode(node)) {
            node = oldNode;
            added = true;
            break;
          }
        }
        if (!added) {
          this.trees.push(new HierarchicalTree(node));
        }
      } else {
        this.trees.push(new HierarchicalTree(node));
      }
      if (_trees.length > 1) {
        this._combineTrees(_trees);
      }
      return node;
    });
  }

  removeTree(_tree) {
    return this.trees = _.reject(this.trees, function(tree) {
      return tree.root === _tree.root;
    });
  }

  removeNode(node) {
    var tree;
    tree = _.find(this.trees, function(tree) {
      return tree.root.id === node.root_id;
    });
    if (!tree) {
      return;
    }
    if (tree.root === node) {
      return this.removeTree(tree);
    } else {
      return tree.removeNode(node);
    }
  }

  findNode(node) {
    var trees;
    if (!(node instanceof HierarchicalTreeNode)) {
      node = new HierarchicalTreeNode(this.nodeParser ? this.nodeParser(node) : node);
    }
    trees = this._findRelaventTreesByRootId(node.root_id);
    if (trees.length === 0) {
      return;
    }
    return trees[0].findNodeByPath(node.ancestry);
  }

  mergeTrees(_trees, place = this.trees.length) {
    if (_trees instanceof Hierarchy) {
      _trees = _trees.trees;
    }
    return this.trees.splice.apply(this.trees, [place, 0].concat(_trees));
  }

  _findRelaventTreesByRootId(_root_id) {
    return _.select(this.trees, function(tree) {
      return tree.root.root_id === _root_id;
    });
  }

  _connectTrees(_parent_node, _child_tree) {
    var _child_node;
    _child_node = _child_tree.root;
    _child_node.parent = _parent_node;
    _parent_node.addChild(_child_node);
    return this.removeTree(_child_tree);
  }

  _combineTrees(_trees) {
    var _destroyed, _parent, _tree, first, i, len, parent, rest;
    [first, ...rest] = _trees;
    if (!rest.length) {
      return;
    }
    parent = _.find(rest, function(_tree) {
      return _tree.root.findDescentByNodeIds(first.root.ancestor_ids);
    });
    if (parent) {
      this._connectTrees(parent.root, first);
    } else {
      _destroyed = [];
      for (i = 0, len = rest.length; i < len; i++) {
        _tree = rest[i];
        _parent = first.root.findDescentByNodeIds(_tree.root.ancestor_ids);
        if (_parent) {
          this._connectTrees(_parent, _tree);
          _destroyed.push(_tree);
        }
      }
      rest = _.difference(rest, _destroyed);
    }
    if (rest.length) {
      return this._combineTrees(rest);
    }
  }

};

export {
  HierarchicalTreeNode,
  HierarchicalTree,
  Hierarchy
};

export default Hierarchy;
